import { render, staticRenderFns } from "./VehicleAssignedList.vue?vue&type=template&id=f965b2d8&scoped=true"
import script from "./VehicleAssignedList.vue?vue&type=script&lang=js"
export * from "./VehicleAssignedList.vue?vue&type=script&lang=js"
import style0 from "./VehicleAssignedList.vue?vue&type=style&index=0&id=f965b2d8&prod&lang=scss&scoped=true"
import style1 from "./VehicleAssignedList.vue?vue&type=style&index=1&id=f965b2d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f965b2d8",
  null
  
)

export default component.exports